module.exports = __webpack_public_path__ + "media/images/pages/secondary-toolkit/python_programming-8b3829c1abaa897f1ceab4828b3a2d36.jpeg";